import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Lock, CheckCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PasswordInput } from '../components/PasswordInput';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SetPasswordPage() {
  const { t, language } = useLanguage();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError(t('ui.setPassword.errMin'));
    if (password !== confirm) return setError(t('ui.setPassword.errMatch'));
    setBusy(true);
    try {
      await axios.post(`${API}/auth/set-password`, { token: params.get('token') || '', password, language });
      setDone(true);
    } catch {
      setError(t('ui.setPassword.errGeneric'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] pt-32 pb-20 px-4" data-testid="set-password-page">
      <div className="max-w-md mx-auto bg-white border border-slate-100 shadow-sm p-8">
        <div className="w-14 h-14 mx-auto mb-6 border border-[#C9A227]/40 flex items-center justify-center">
          {done ? <CheckCircle className="w-6 h-6 text-green-600" /> : <Lock className="w-6 h-6 text-[#C9A227]" />}
        </div>
        <h1 className="font-serif text-3xl text-center text-[#283880] mb-2">{done ? t('ui.setPassword.titleDone') : t('ui.setPassword.title')}</h1>
        {done ? (
          <>
            <p className="text-center text-slate-500 mb-6">{t('ui.setPassword.doneText')}</p>
            <Button onClick={() => navigate('/login')} className="w-full bg-[#283880]" data-testid="set-password-go-login">{t('ui.setPassword.goLogin')}</Button>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <PasswordInput placeholder={t('ui.setPassword.placeholder')} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="set-password-input" />
            <PasswordInput placeholder={t('ui.setPassword.confirm')} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="set-password-confirm" />
            {error && <p className="text-sm text-red-600" data-testid="set-password-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-[#283880]" data-testid="set-password-submit">
              {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />} {t('ui.setPassword.save')}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
